import { $updateProgressCooldownValues, $userLanguage, $userToken } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { useTimer } from '@/shared/hooks/useTimer'
import { darkTheme } from '@/shared/styles/theme/dark'
import { AppButton } from '@/shared/ui/button'
import { Icon } from '@/shared/ui/icon'
import { ProgressBar } from '@/shared/ui/progressBar'
import { useUnit } from 'effector-react'
import { useStyles } from './styles'
import { useState } from 'react'
import { useGetLastTimeForCooldown } from '@/shared/hooks/useGetLastTimeForCooldown'
import { getUserProfileFx } from '@/entities/user'
import { getEpicRefreshFx } from '@/entities/platforms/egs/effects'
import { getSteamRefreshFx } from '@/entities/platforms/steam/effects'
import WebApp from '@twa-dev/sdk'
import { getScoringInvoice } from '@/entities/payments/api'
import { getXboxRefreshFx } from '@/entities/platforms/xbox'

export const UpdateProgressButton = () => {
  const userLang = useUnit($userLanguage)
  const userToken = useUnit($userToken)
  const updateCooldownValues = useUnit($updateProgressCooldownValues);
  const { classes } = useStyles()

  const { startDate, endDate } = useGetLastTimeForCooldown({
    ...updateCooldownValues,
    kind: 'scoring',
  })

  const [isRefreshing, setIsRefreshing] = useState(false)

  const { skipPrice, progressBarWidth, timeLeft, canUpdate } = useTimer(endDate.toISOString(), startDate.toISOString())

  const texts = lang[userLang].pages.profile

  async function handleRefreshProgress() {
    if (userToken) {
      setIsRefreshing(true)
      try {
        await getSteamRefreshFx(userToken)
        await getEpicRefreshFx(userToken)
        await getXboxRefreshFx(userToken)
        localStorage.setItem('lastUpdateDate', new Date().toISOString())
        await getUserProfileFx(userToken)
      } finally {
        setTimeout(() => {
          setIsRefreshing(false)
        }, 2000)
      }
    }
  }

  const [isLoading, setIsLoading] = useState(false)
  async function handleBuyUpdate() {
    setIsLoading(true)
    const link = await getScoringInvoice(userToken!)
    WebApp.openInvoice(link.invoice_link, (status) => {
      if (status === 'paid') {
        getUserProfileFx(userToken!)
      }
      setIsLoading(false)
    })
  }

  return (
    <div className={classes.root}>
      <AppButton
        className={classes.updateProgressButton}
        style={{ background: isRefreshing ? '#37752F' : '' }}
        onClick={canUpdate ? handleRefreshProgress : undefined}
        disabled={!canUpdate}
      >
        {isRefreshing ? (
          <Icon
            view="updating"
            width={20}
            style={{ position: 'relative', zIndex: 10, animation: 'testing 1s linear infinite' }}
          />
        ) : (
          <Icon
            view="lightning"
            width={20}
            style={{ position: 'relative', zIndex: 10 }}
          />
        )}
        <span>
          {isRefreshing
            ? texts.updating
            : canUpdate
            ? texts.updateProgress
            : `${texts.updateIn} ${timeLeft.hours}:${timeLeft.minutes}:${timeLeft.seconds}`}
        </span>

        {!isRefreshing && (
          <ProgressBar
            width={progressBarWidth}
            color={darkTheme.colors.button.primary.background}
          />
        )}
      </AppButton>
      {!canUpdate && !isRefreshing && (
        <AppButton
          isLoading={isLoading}
          onClick={handleBuyUpdate}
          className={classes.updateNowButton}
        >
          <Icon
            view="rocket"
            width={20}
          />
          <span>
            {texts.now} {skipPrice}
          </span>
          <Icon
            view="tgStar"
            width={20}
          />
        </AppButton>
      )}
    </div>
  )
}
